/*
 *  CONSIDER THIS: https://github.com/amiel/html5support
 *
 *  We can roll our own solution for html 5 support that is a bit leaner and includes the other placeholder plugin, etc...
 */
import 'app/page/failed-login.less';

(function() {
    var _init = function(){
    	$('#id').placeholder();
    	$('#pattern').placeholder();
        if (!Modernizr.touch && Modernizr.input.placeholder) {
            $('#id').focus();
        }

        var str = window.location.href.split('?')[1];
        if (str === 'failed_login=true' || (str != null && str.startsWith('failed_login=true'))) {
            $('.failedlogin-error-message').show();
            const element =  document.querySelector('.failedlogin-error-message');
            element.classList.add('animated', 'shake', 'slower');
        }

        $('#failed-login-submit').click(function(){
            if(!$('#id').val().length || !$('#pattern').val().length) {
                $('.failedlogin-error-message').show();
                const element =  document.querySelector('.failedlogin-error-message');
                element.classList.add('animated', 'shake', 'slower');
                return false;
            }
            return true;
        });


        $(document).ready(function(){
            $('#failed-login-submit').attr('disabled',true);
            $('.floating-input-container input').keyup(function() {

                var empty = false;
                $('.floating-input-container input').each(function() {
                    if ($(this).val().length == 0) {
                        empty = true;
                    }
                });

                if (empty) {
                    $('#failed-login-submit').attr('disabled', 'disabled');
                } else {
                    $('#failed-login-submit').removeAttr('disabled');
                }
            });
        });
    };

    _init();

})();




/** WEBPACK FOOTER **
 ** ./javascript/app/page/card-login.js
 **/